import React from "react";

import { isMobileDevice } from "utils";

export default (WrappedComponent) =>
  class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isHovered: false,
      };
      this.handleMouseEnter = this.handleMouseEnter.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);
    }

    handleMouseEnter() {
      this.setState({ isHovered: true });
    }

    handleMouseLeave() {
      this.setState({ isHovered: false });
    }

    render() {
      if (isMobileDevice()) {
        return (
          <div>
            <WrappedComponent isHovered {...this.props} />
          </div>
        );
      }

      return (
        <div onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
          <WrappedComponent isHovered={this.state.isHovered} {...this.props} />
        </div>
      );
    }
  };
